module.exports = __webpack_public_path__ + "static/media/rhd_6.40259318.png";